import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Header from "src/components/UI/Header/Header";
import VerticalNavBar from "src/components/UI/VerticalNavBar/VerticalNavBar";
import { configurationNavigation } from "src/configurationNavigation";
import { setIsCollapsed } from "src/redux/slices/ConfigurationLayoutSlice";
import { RootState } from "src/redux/store";


type Props = {
  children?: React.ReactNode | string;
};

const ConfigurationLayout = ({ children }: Props) => { 
  const dispatch = useDispatch()
 
  const { isCollapsed }: any = useSelector(
    (state: RootState) => state.configurationLayout
  );

  const toggleCollapse = () => { dispatch(setIsCollapsed(!isCollapsed))};
  const location = useLocation();
  const currentPath = `${location.pathname?.split("/")[2]}`;

  return (
    <div className="flex h-screen w-screen relative" tabIndex={0}>
      {/* Side Navigation Bar */}
      <VerticalNavBar
        toggleCollapse={toggleCollapse}
        isCollapsed={isCollapsed}
        navigation={configurationNavigation}
        isPathEqualtoNavItem={(navItem: any) => navItem.path === currentPath}
      />

      <div
        className={`h-full flex flex-col transition-all duration-500 ${
          isCollapsed ? "w-full" : "w-[calc(100%-230px)]"
        } `}
      >
        {/* Header */}
        <div className="h-[50px]">
          <Header toggleCollapse={toggleCollapse} isCollapsed={isCollapsed} />
        </div>

        <div className="flex-1 overflow-y-auto ">
          <Outlet />
        </div>
      </div>

      {/* <div className="absolute bottom-0 left-0 z-50 w-[230px] p-4">
        <button
          type="button"
          className="text-primary-main px-4 rounded-lg py-2 w-full text-start flex gap-2 justify-center items-center bg-white font-semibold  group/item "
          onClick={() => {
            navigate("/welcome");
          }}
        >
          <FiChevronsLeft
            size={24}
            className="group-hover/item:-translate-x-2 transition-all duration-500"
          />
          <span className="leading-none"> Back To Menu</span>
        </button>
      </div> */}
    </div>
  );
};

export default ConfigurationLayout;
